import React from "react";
import Top from "./Top";
import Middle from "./Middle";
import Bottom from "./Bottom";
import LastOne from "./LastOne";
import Navbar from "../../componets/Navbar";
import Footer from "../../componets/Footer";
const About = () => {
  return (
    <>
      <Navbar />
      <Top />
      <Middle />
      <Bottom />
      <LastOne />
      <Footer />
    </>
  );
};

export default About;
